<template>
  <div class="demo-spin-article">
    <div class="ls_action_header">
      <Row class="ls_action_header mb-24" style="padding-top: 6px" type="flex" :gutter="24" justify="space-between">

        <Col :xs="24" :sm="24" :md="24" :lg="0">
          <Row type="flex" :gutter="24">
            <Col :xs="24" :sm="24" :md="12" :lg="0" class="mb-10">
              <Button
                type="primary"
                class="ls_bulk_delete_button font-bold w-lg-100"
                @click="showGroupModal = true"
              >{{ groupButtonName }}
                <Icon type="ios-arrow-down"/>
              </Button>
              <Modal
                v-model="showGroupModal"
                @on-cancel=""
                title="Выберите группу товаров"
              >
                <!--<div style="margin-top: 25px;">-->
                <!--<Input search placeholder="Введите название группы" />-->
                <Tree
                  :data="groupData"
                  :load-data="fetchChildrenGroups"
                  @on-select-change="selectGroup"
                ></Tree>
                <!--</div>-->
                <div slot="footer">
                  <Button
                    type="error"
                    size="large"
                    @click="showGroupModal = false"
                  >Отменить
                  </Button
                  >
                </div>
              </Modal>
            </Col>


            <Col :xs="24" :sm="24" :md="12" :lg="0" class="mb-10">
              <Select
                class="br-18 w-lg-100"
                v-model="filter.store"
                clearable
                placeholder="Магазин/Склад"
              >
                <Option
                  v-for="item in filterOptions.store"
                  :value="item.id"
                  :key="item.id"
                >{{ item.name }}
                </Option
                >
              </Select>
            </Col>
          </Row>
        </Col>


        <Col :xs="24" :sm="24" :md="24" :lg="0">
          <Row type="flex" :gutter="24">
            <Col :xs="24" :sm="24" :md="12" :lg="0" class="mb-10">
              <!-- TEXT SEARCH -->
              <Input
                class="search-input w-lg-100"
                placeholder="Введите наименование/штрихкод товара"
                v-model="searchString"
              >
                <Icon type="ios-search" slot="suffix"/>
              </Input>
            </Col>


            <Col :xs="24" :sm="24" :md="12" :lg="0" class="mb-10 custom-dropdown">
              <Dropdown class="w-lg-100">
                <Button type="info" class="w-lg-100">
                  Действия c товаром/услугой
                  <Icon type="ios-arrow-down"></Icon>
                </Button>
                <DropdownMenu slot="list">

                  <router-link to="/pdocs/create?type=SELL" class="card-container">
                    <DropdownItem>
                      Продажа
                    </DropdownItem>
                  </router-link>

                  <router-link to="/pdocs/create?type=PURCHASE" class="card-container">
                    <DropdownItem>
                      Закупка
                    </DropdownItem>
                  </router-link>

                  <router-link to="/pdocs/create?type=RETURN_SELL" class="card-container">
                    <DropdownItem>
                      Возврат продажи
                    </DropdownItem>
                  </router-link>

                  <router-link to="/pdocs/create?type=RETURN_PURCHASE" class="card-container">
                    <DropdownItem>
                      Возврат закупки
                    </DropdownItem>
                  </router-link>

                  <router-link to="/pdocs/changes_in/create" class="card-container">
                    <DropdownItem>
                      Оприходование
                    </DropdownItem>
                  </router-link>

                  <router-link to="/pdocs/changes_out/create" class="card-container">
                    <DropdownItem>
                      Списание
                    </DropdownItem>
                  </router-link>

                  <router-link to="/pdocs/changes_moving/create" class="card-container">
                    <DropdownItem>
                      Перемещение
                    </DropdownItem>
                  </router-link>

                  <router-link to="/pdocs/inventory/create" class="card-container">
                    <DropdownItem>
                      Инвентаризация
                    </DropdownItem>
                  </router-link>


                </DropdownMenu>
              </Dropdown>

            </Col>


          </Row>
        </Col>


        <!--          <Select-->
        <!--                  v-model="filter.store"-->
        <!--                  style="width:150px; text-align: left"-->
        <!--                  clearable-->
        <!--                  placeholder="Магазин"-->
        <!--          ><Option-->
        <!--                  v-for="item in filterOptions.store"-->
        <!--                  :value="item.id"-->
        <!--                  :key="item.id"-->
        <!--          >{{ item.name }}</Option></Select>-->


        <!--<FormItem label="Switch">-->
        <!--          <span style="margin-left: 20px;"-->
        <!--            >Доп.фильтр-->
        <!--            <i-switch @on-change="toogleFilter" label="Доп.фильтр"></i-switch-->
        <!--          ></span>-->
        <!--<Button v-if="showClearFilter" type="text" @click="clearFilter"-->
        <!--&gt;Сбросить фильтр</Button-->
        <!--&gt;-->


      </Row>

      <Row class="mb-15">
        <Button v-if="showClearFilter" @click="clearFilter" type="error"
        >Сбросить фильтр
        </Button>
      </Row>

      <!-- FILTER -->
      <!--      <Row :gutter="10" type="flex" justify="center" v-show="filterShow">-->
      <!--        <Col-->
      <!--          ><Select-->
      <!--            v-model="filter.product_type"-->
      <!--            style="width:130px"-->
      <!--            clearable-->
      <!--            placeholder="Тип"-->
      <!--            ><Option-->
      <!--              v-for="item in filterOptions.product_type"-->
      <!--              :value="item.value"-->
      <!--              :key="item.value"-->
      <!--              >{{ item.label }}</Option-->
      <!--            >-->
      <!--          </Select></Col-->
      <!--        >-->

      <!--        <Col-->
      <!--        ><Select-->
      <!--          v-model="filter.product_supplier"-->
      <!--          style="width:300px"-->
      <!--          clearable-->
      <!--          placeholder="Поставщик"-->
      <!--        ><Option-->
      <!--          v-for="item in filterOptions.product_supplier"-->
      <!--          :value="item.id"-->
      <!--          :key="item.id"-->
      <!--        >{{ item.name }}</Option-->
      <!--        >-->
      <!--        </Select></Col-->
      <!--        >-->
      <!--      </Row>-->
    </div>
    <!-- DATA TABLE + PAGINATION -->
    <Table
      class="desktop_table"
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>

    <!-- DATA MOBILE TABLE -->
    <div class="mobile-table">

      <router-link :to="item_type + '/detail/' + item.product_id" v-for="item in data" class="card-container">
        <div>
          <h2>{{item.product_name}}</h2>
          <p>Код: {{item.product_barcode}}</p>
          <p>Ед.изм.: {{item.product_unit}}</p>
          <p>Торговая точка: {{item.store_name}}</p>
          <p>Категория (группа) товаров: {{item.product_group}}</p>
          <p>Остатки: {{formatNumber(item.rest)}} </p>
          <p>Средняя сумма остатков: {{formatNumber(item.rest_sum)}} {{currency}} </p>
        </div>

        <div>
          <p class="price">{{formatNumber(item.product_purchase)}} {{currency}}</p>
        </div>

      </router-link>
    </div>


    <Page
      :total="totalRecords"
      :page-size="pageSize"
      :page-size-opts="[15, 25, 35]"
      @on-change="changePage"
      @on-page-size-change="changePageSize"
      show-sizer
      :styles="{ marginTop: '30px', float: 'right' }"
    />

    <!-- ITEM VIEW -->
    <catalogItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewItemUrl"
      :item_type="item_type"
    ></catalogItem>
  </div>
</template>
<script>
    import {base_url} from "../../http.js";
    import {formatNumber} from "../../base/base_func.js";
    import {BaseTableData} from "../../base/base_table.js";
    import catalogItem from "@/apps/catalog/catalogItem.vue";

    let _app = BaseTableData();


    _app.components = {
        catalogItem
    };

    _app.name = "warehouse";
    _app.data = function () {
        return {
            // Base settings
            baseViewUrl: base_url + "/catalog/warehouse/",
            baseViewItemUrl: base_url + "/catalog/products/",
            item_type: "warehouse",
            loading: true,
            //currency: localStorage.getItem('currency'),

            // Table settings
            columns: [
                {
                    title: "Наименование",
                    maxWidth: 400,
                    key: "product_name",
                    render: (h, params) => {
                      return h(
                        "router-link",
                        {
                          props: {
                            to: {
                              name: this.item_type + "_detail",
                              params: { id: params.row.product_id }
                            }
                          }
                        },
                        params.row.product_name
                      );
                    }
                },
                {
                    title: "Код",
                    // width: 150,
                    // maxWidth: 140,
                    key: "product_barcode",
                    sortable: true,
                    align: "center"
                },

                {
                    title: "Ед.изм.",
                    maxWidth: 80,
                    key: "product_unit",
                    align: "center"
                },
                {
                    title: "Торговая точка",
                    key: "store_name",
                    // width: 100,
                    align: "center"
                },
                {
                    title: "Категория (группа) товара",
                    // width: 60,
                    key: "product_group",
                    // width: 100,
                    align: "center"
                },
                // {
                //   title: "Поставщик",
                //   // width: 60,
                //   key: "product_supplier",
                //   sortable: true,
                //   // width: 100,
                //   align: "center"
                // },
                {
                    title: "Остатки",
                    // width: 60,
                    key: "rest",
                    sortable: true,
                    // width: 100,
                    align: "center",
                    render: (h, params) => {
                        return h("span", {}, formatNumber(params.row.rest));
                    }
                },
                {
                    title: "Средняя сумма остатков",
                    // width: 60,
                    key: "rest_sum",
                    sortable: true,
                    // width: 100,
                    align: "center",
                    render: (h, params) => {
                        return h("span", {}, formatNumber(params.row.rest_sum) + ' ' + this.currency);
                    }
                },
                {
                    title: "Средняя цена закупки",
                    // width: 60,
                    key: "product_purchase",
                    sortable: true,
                    // width: 100,
                    align: "right",
                    render: (h, params) => {
                        return h("span", {}, formatNumber(params.row.product_purchase) + ' ' + this.currency);
                    }
                }
                // {
                //   title: "Цена закупки за ед.",
                //   // width: 90,
                //   key: "base_price",
                //   sortable: true,
                //   // width: 150,
                //   align: "right",
                //   render: (h, params) => {
                //     return h("span", {}, formatNumber(params.row.purchase) + ' ' + this.currency);
                //   }
                // },
                // {
                //   title: "Цена продажи за ед.",
                //   // width: 90,
                //   key: "base_price",
                //   sortable: true,
                //   // width: 150,
                //   align: "right",
                //   render: (h, params) => {
                //     return h("span", {}, formatNumber(params.row.base_price) + ' ' + this.currency);
                //   }
                // },
                // {
                //   title: "Скидка",
                //   // width: 100,
                //   key: "discount",
                //   sortable: true,
                //   align: "right",
                //   render: (h, params) => {
                //     return h("span", {}, params.row.discount + ' %');
                //   }
                // },
                // {
                //   title: "Действия",
                //   // key: 'action',
                //   width: 100,
                //   align: "center",
                //   render: (h, params) => {
                //     let buttons = [];
                //     if (this.display_edit_button_by_row(params.row)) {
                //       buttons.push(
                //         h(
                //           "Tooltip",
                //           {
                //             props: {
                //               content: "Редактировать"
                //             }
                //           },
                //           [
                //             h("Button", {
                //               props: {
                //                 to: {
                //                   name: this.item_type + "_edit",
                //                   params: { id: params.row.id }
                //                 },
                //                 type: "primary",
                //                 size: "small",
                //                 // icon: 'ios-information-circle-outline',
                //                 icon: "ios-create-outline",
                //                 ghost: "ghost"
                //               },
                //               style: {
                //                 marginRight: "5px"
                //               }
                //             })
                //           ]
                //         ),
                //       );
                //     }
                //     if (this.display_delete_button_by_row(params.row)) {
                //       buttons.push(
                //         h(
                //           "Tooltip",
                //           {
                //             props: {
                //               content: "Удалить"
                //             }
                //           },
                //           [
                //             h("Button", {
                //               props: {
                //                 type: "error",
                //                 size: "small",
                //                 icon: "ios-trash-outline",
                //                 ghost: "ghost"
                //               },
                //               on: {
                //                 click: () => {
                //                   this.deleteItem(params.row.id);
                //                 }
                //               }
                //             })
                //           ]
                //         )
                //       );
                //     }
                //
                //     return h("div", buttons);
                //   }
                // }
            ],
            data: [],
            lastDraw: 0,
            totalRecords: null,
            currentPage: 1,
            pageSize: 15,
            sorting: "",
            searchString: "",
            // showClearFilter: false,

            filterShow: false,
            filter: {
                // product_type: "",
                store: "",
                product_supplier: "",
                // applied: "",
                // order_date__gt: "",
                // order_date__lt: "",
                product_group: ""
            },
            filterOptions: {
                // product_type: [
                //   {
                //     value: "PRODUCT",
                //     label: "Продукт"
                //   },
                //   {
                //     value: "SERVICE",
                //     label: "Услуга"
                //   },
                //   {
                //     value: "KIT",
                //     label: "Комплект"
                //   }
                // ],
                store: [],
                product_supplier: []
                // applied: [
                //   {
                //     value: "true",
                //     label: "Проведен"
                //   },
                //   {
                //     value: "false",
                //     label: "Не проведен"
                //   }
                // ],
            },

            // selected: [],

            item: {
                show: false,
                id: null,
                action: null
            },

            loadedGroups: false,
            showGroupModal: false,
            groupData: [],
            selectedGroupName: ""
        };
    };

    _app.computed.groupButtonName = function () {
        return this.selectedGroupName && this.filter.product_group
            ? this.selectedGroupName
            : "Выбрать группу";
    };
    // _app.computed.display_edit_button = function() {
    //   return (
    //     this.permissions.indexOf("catalog.product_update_all") !== -1 ||
    //     this.permissions.indexOf("catalog.product_update_owner") !== -1
    //   );
    // };
    _app.computed.display_delete_button = function () {
        return (
            this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
            this.permissions.indexOf("catalog.product_delete_owner") !== -1
        );
    };
    _app.computed.display_create_button = function () {
        return this.permissions.indexOf("catalog.product_create") !== -1;
    };

    _app.methods.display_edit_button_by_row = function (row) {
        if ("can_update" in row) {
            return (
                row.can_update &&
                (this.permissions.indexOf("catalog.product_update_all") !== -1 ||
                    this.permissions.indexOf("catalog.product_update_owner") !== -1)
            );
        }
        return (
            this.permissions.indexOf("catalog.product_update_all") !== -1 ||
            this.permissions.indexOf("catalog.product_update_owner") !== -1
        );
    };

    _app.methods.display_delete_button_by_row = function (row) {
        if ("can_delete" in row) {
            return (
                row.can_delete &&
                (this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
                    this.permissions.indexOf("catalog.product_delete_owner") !== -1)
            );
        }
        return (
            this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
            this.permissions.indexOf("catalog.product_delete_owner") !== -1
        );
    };

    // Переключения режима "Доп.фильтр"
    _app.methods.toogleFilter = function (val) {
        this.filterShow = val;

        // Если убираем фильтр - очищаем все поля фильтра
        if (!val) {
            for (let key in this.filter) {
                this.filter[key] = "";
            }

            // Дополнительная очистка фильтров (Даты документа)
            this.filterOrderDate = [];
        }
    };

    // Очистка фильтров
    _app.methods.clearFilter = function () {
        // Очистка общих фильтров и посика
        if (this.searchString) {
            this.searchString = "";
        }
        for (let key in this.filter) {
            if (this.filter[key]) {
                this.filter[key] = "";
            }
        }

        // Дополнительная очистка фильтров (Даты документа)
        this.filterOrderDate = [];

        // Перезагрузка групп
        this.loadedGroups = false;
    };

    _app.methods.changeFilterOrderDate = function (date_arr, date_obj) {
        if (date_arr[0] && date_arr[1]) {
            this.filter.order_date__gt = this.filterOrderDate[0];
            this.filter.order_date__lt = this.filterOrderDate[1];

            // this.filter.order_date__gt = date_arr[0] + 'T00:00:00';
            // this.filter.order_date__lt = date_arr[1] + 'T00:00:00';
        }
    };

    // Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
    _app.methods.clearFilterOrderDate = function (date_arr, date_obj) {
        this.filter.order_date__gt = "";
        this.filter.order_date__lt = "";
    };

    _app.methods.fetchGroups = function () {
        const url = base_url + "/catalog/groups/?parent=true";
        this.$http.get(url).then(result => {
            if (result.data.results) {
                this.groupData = [];
                for (const item of result.data.results) {
                    let item_data = {
                        id: item.id,
                        title: item.name
                        // loading: false,
                    };
                    if (item.has_children) {
                        item_data.children = [];
                        item_data.loading = false;
                    }
                    this.groupData.push(item_data);
                }
                this.loadedGroups = true;
            }
        });
    };

    _app.methods.fetchChildrenGroups = function (item, callback) {
        const url = base_url + `/catalog/groups/${item.id}/children/`;
        this.$http.get(url).then(result => {
            if (result.data.results) {
                let data = [];
                for (const item of result.data.results) {
                    let item_data = {
                        id: item.id,
                        title: item.name
                    };
                    if (item.has_children) {
                        item_data.children = [];
                        item_data.loading = false;
                    }
                    data.push(item_data);
                }
                callback(data);
            }
        });
    };

    _app.methods.selectGroup = function (item, callback) {
        this.showGroupModal = false;
        this.filter.product_group = item[0].id;
        this.selectedGroupName = item[0].title;
    };

    _app.methods.getStores = function () {
        const url = base_url + "/stores/";
        this.$http
            .get(url)
            .then(result => {
                this.filterOptions.store = result.data.results;
            })
            .catch(error => {
                this.$Message.error("Произошла ошибка");
            });
    };

    _app.methods.getSuppliers = function () {
        const url = base_url + "/suppliers/";
        this.$http
            .get(url)
            .then(result => {
                this.filterOptions.product_supplier = result.data.results;
            })
            .catch(error => {
                this.$Message.error("Произошла ошибка");
            });
    };


    _app.created = function () {
        this.getStores();
        this.getSuppliers();
    };

    _app.watch["showGroupModal"] = function () {
        if (!this.loadedGroups) this.fetchGroups();
    };

    // _app.methods.showCategoryModal = function() {
    //   const title = 'Title';
    //   const content = '<p>Content of dialog</p><p>Content of dialog</p>';
    //       this.$Modal.info({
    //         title: title,
    //         content: content
    //       });
    // };
    export default _app;
</script>

<style scoped>
  .search-input {
    width: 400px;
  }

  @media screen and (max-width: 1900px) {
    .search-input {
      width: 360px;
    }
  }

  @media screen and (max-width: 1500px) {
    .search-input {
      width: 350px;
    }


  }

  @media screen and (max-width: 991px) {
    .w-lg-100 {
      width: 100%;
    }
  }
</style>


<style>
  @media (min-width: 992px) {
    .ivu-col-span-lg-0 {
      display: block;
      width: auto;
    }

  }
</style>



// WEBPACK FOOTER //
// src/apps/catalog/warehouse.vue